module.exports = __webpack_public_path__ + "static/media/globe.27da5264.png";